// extracted by mini-css-extract-plugin
module.exports = {"table":"reportSalaryDetail_table__VxyH7","hidden":"reportSalaryDetail_hidden__1x0Zj"};